import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './ListItemNumber.module.scss'

export const ListItemNumber: FunctionComponent<Props> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <li className={classnames(styles.listItemNumber, className)} {...rest}>
      {children}
    </li>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  className?: string
  children: ReactNode
} & HTMLProps<HTMLLIElement>
